import React, { useEffect, useState } from 'react';
import { superAdminApi } from '@/services/superAdminApi';
import { toast } from 'sonner';
import { MessageSquareText } from 'lucide-react';
import { WhatsAppCatalogView } from '@/components/whatsapp/WhatsAppCatalogView';

export default function WhatsAppTemplatesPage() {
  const [data, setData] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [submitting, setSubmitting] = useState('');

  const load = async () => {
    try {
      const r = await superAdminApi.waTemplatesCatalog();
      setData(r.data);
    } catch {
      toast.error('Vorlagen konnten nicht geladen werden');
    }
  };

  useEffect(() => { load(); }, []);

  const onSubmit = async (key, lang) => {
    setSubmitting(lang ? `${key}:${lang}` : `${key}:all`);
    try {
      const r = await superAdminApi.waTemplatesSubmit({ key, lang: lang || undefined });
      if (r.data?.success) toast.success('Zur Meta-Prüfung eingereicht');
      else toast.warning('Teilweise eingereicht — Details im Status');
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Einreichen fehlgeschlagen');
    } finally {
      setSubmitting('');
    }
  };

  const onSync = async () => {
    setSyncing(true);
    try {
      const r = await superAdminApi.waTemplatesSync();
      toast.success(`Status aktualisiert (${r.data?.synced ?? 0})`);
      await load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Aktualisieren fehlgeschlagen');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div data-testid="sa-whatsapp-templates-page">
      <div className="mb-6">
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900">
          <MessageSquareText className="h-6 w-6 text-emerald-600" /> WhatsApp-Vorlagen (Invicta)
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Zentrale Vorlagen für die Invicta-Fallback-Nummer. Mit einem Klick bei Meta zur Prüfung einreichen.
        </p>
      </div>
      <WhatsAppCatalogView
        data={data}
        onSubmit={onSubmit}
        onSync={onSync}
        syncing={syncing}
        submitting={submitting}
        configHint="Konfiguration unter Abrechnung → Invicta-Zustellung → WhatsApp."
      />
    </div>
  );
}
